import React, { useState, useEffect } from 'react';

// Non-invasive "new version available" banner.
// index.html dispatches 'memo-update-available' when a new service worker has
// finished installing (instead of force-reloading mid-session). Tapping
// "Update" calls window.__memoApplyUpdate(), which activates the waiting worker
// → 'controllerchange' fires → the page reloads with the new code. If the user
// ignores it, the update applies naturally next time the app is fully closed.
export default function UpdateBanner({ T }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // A new SW may have installed before this listener was attached.
    if (typeof window !== 'undefined' && window.__memoWaitingWorker) setShow(true);
    const onUpdate = () => setShow(true);
    window.addEventListener('memo-update-available', onUpdate);
    return () => window.removeEventListener('memo-update-available', onUpdate);
  }, []);

  if (!show) return null;

  const s = (T && T.settings) || {};

  function apply() {
    try { window.__memoApplyUpdate && window.__memoApplyUpdate(); } catch (_) {}
    // Fallback: if the SW handshake doesn't fire controllerchange, reload anyway.
    setTimeout(() => { try { window.location.reload(); } catch (_) {} }, 1500);
  }

  return (
    <div role="status" style={{
      position: 'fixed', left: 12, right: 12, bottom: 78, zIndex: 1200,
      background: 'var(--color-primary)', color: '#fff', borderRadius: 12,
      boxShadow: '0 6px 20px rgba(0,0,0,0.22)', padding: '12px 14px',
      display: 'flex', alignItems: 'center', gap: 12, fontSize: '0.9rem',
    }}>
      <span style={{ flex: 1, lineHeight: 1.35 }}>
        {s.updateAvailable || 'A new version is available.'}
      </span>
      <button type="button" onClick={apply} style={{
        background: '#fff', color: 'var(--color-primary-dark)', border: 'none',
        borderRadius: 8, padding: '7px 14px', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
      }}>
        {s.updateButton || 'Update'}
      </button>
      <button type="button" aria-label="dismiss" onClick={() => setShow(false)} style={{
        background: 'transparent', color: '#fff', border: 'none', fontSize: '1.2rem',
        cursor: 'pointer', lineHeight: 1, padding: '2px 4px', opacity: 0.85,
      }}>
        ×
      </button>
    </div>
  );
}
